export default "__VITE_ASSET__CBvhYXSJ__"